<template>
  <div class="st-input">
    <label class="st-input__label" v-if="labelName" :for="$attrs.id">
      {{ labelName }}
    </label>
    <div :class="classList">
      <input
        v-bind="$attrs"
        :type="computedType"
        :value="modelValue"
        :autocomplete="autocomplete"
        class="st-input__container__input-field"
        :aria-invalid="invalid ? 'true' : null"
        @blur="onBlur"
        @focus="onFocus"
        @input="$emit('update:modelValue', $event.target.value)"
        @keyup.esc="$emit('update:modelValue', '')"
      />
      <div class="st-input__container__component">
        <slot> </slot>
      </div>
    </div>
    <div class="st-input__action" v-if="$attrs.type === 'password'">
      <st-checkbox :id="`${$attrs.id}-checkbox`" v-model="showingPassword">
        <span>Visa lösenord</span></st-checkbox
      >
    </div>
  </div>
</template>

<script>
import StCheckbox from "../checkbox/Checkbox.vue";

export default {
  name: "st-input",
  inheritAttrs: false,
  components: {
    StCheckbox,
  },
  data() {
    return {
      localValue: this.value,
      showingPassword: false,
    };
  },
  props: {
    modelValue: {
      type: String,
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    blur: {
      type: Function,
    },
    focus: {
      type: Function,
    },
    labelName: {
      type: String,
    },
  },

  computed: {
    classList() {
      const input = "st-input__container";
      return [
        input,
        this.invalid && `${input}--is-invalid`,
        this.$attrs.disabled && `${input}--is-disabled`,
      ];
    },
    computedType() {
      if (this.$attrs.type === "password") {
        return this.showingPassword ? "text" : "password";
      }
      return this.$attrs.type || "text";
    },
  },

  methods: {
    onBlur() {
      if (this.blur) {
        this.blur();
      } else {
        this.$emit("blur");
      }
    },
    onFocus() {
      if (this.focus) {
        this.focus();
      } else {
        this.$emit("focus");
      }
    },
  },
  emits: ["update:modelValue", "blur", "focus"],
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-input {
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  &__label {
    color: var(--text-color-primary);
    font-family: var(--font-primary);
    padding-left: var(--xs);
    margin-bottom: rem-calc(2);
    font-size: rem-calc(14);
    font-weight: 600;
    line-height: 1.4;
    text-align: left;
  }
  &__container {
    background-color: var(--background-color-secondary);
    display: flex;
    align-items: center;
    border: var(--border-width--thin) solid var(--border-color-quaternary);
    border-radius: var(--border-radius);
    color: var(--text-color-primary);
    font-family: var(--font-primary);
    width: 100%;
    transition: 0.2s linear border-color;
    height: rem-calc(48);
    &:focus-within {
      box-shadow: 0 0 0 rem-calc(2) var(--background-color-secondary),
        0 0 0 rem-calc(4) var(--border-color-quaternary);
      border-radius: var(--border-radius);
      outline: none;
    }

    &--is-invalid {
      border-color: var(--danger-color-primary);
      border-width: var(--border-width--thin);
    }

    &--is-disabled {
      background-color: var(--disabled-color-tertiary);
    }

    &__component > * {
      margin: 0 var(--md);
    }

    &__input-field {
      border-color: transparent;
      background-color: var(--background-color-secondary);
      border: 0;
      border-radius: var(--border-radius);
      color: var(--text-color-primary);
      font-family: var(--font-primary);
      width: 100%;
      height: 100%;
      padding-left: rem-calc(12);
      padding-right: rem-calc(12);
      font-size: rem-calc(16);
      line-height: 1.5;
      margin-bottom: 0;

      &:focus {
        outline: none;
      }

      &::placeholder {
        color: var(--palette-secondary-600);
      }

      &:disabled,
      &:read-only {
        background-color: var(--disabled-color-tertiary);
        cursor: not-allowed;
      }
    }
  }
  &__action {
    margin-top: rem-calc(8);
  }
}
</style>
